import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1>Bhaktinaad Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 05/08/2025</p>

      <p>
        Bhaktinaad is committed to protecting your privacy. This Privacy Policy explains how we collect,
        use, and protect your information when you use our app.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li>Personal Information: We collect information you provide when creating an account (name, email, etc.).</li>
        <li>Usage Information: We collect details about how you use our app.</li>
        <li>Device Information: We may collect device-specific info (model, OS version, etc.).</li>
        <li>Payment Information: For demo versions, we use Razorpay in test mode. We do not store or process payment details on our servers.</li>
        <li>Media Access: We request permission to store wallpapers you download on your device.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide and improve our services.</li>
        <li>To communicate with you about your account or our services.</li>
        <li>For marketing and promotional purposes (with your consent).</li>
      </ul>

      <h2>Data Protection</h2>
      <p>We implement security measures to protect your information from unauthorized access or disclosure.</p>

      <h2>Cookies and Tracking</h2>
      <p>
        We may use cookies and similar technologies to enhance your experience. We also use Google AdMob to show
        personalized ads based on your app usage and interests. These services may collect anonymous identifiers
        or usage behavior.
      </p>

      <h2>Third-Party Services</h2>
      <p>We use third-party services to support app functionality, such as:</p>
      <ul>
        <li>Google AdMob: For displaying advertisements</li>
        <li>Razorpay: For payment processing (in test/demo mode during early versions)</li>
        <li>Media Store Access: To save downloaded wallpapers to your device</li>
      </ul>
      <p>These services have their own privacy policies, and we recommend reviewing them.</p>

      <h2>Your Rights</h2>
      <ul>
        <li>You can deny storage permissions if you don’t want wallpapers downloaded to your device.</li>
        <li>You may choose to opt out of personalized ads via your device settings.</li>
        <li>During test versions, payment services are for demonstration only and do not collect real payment information.</li>
      </ul>

      <h2>Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Changes will be posted on this page.</p>

      <h2>Data Deletion Request</h2>
      <p>
        Users may request deletion of their account and associated data by contacting us at mohit.shirole@gbisinc.com. Once we receive a valid request, the data will be permanently deleted within 2-3 days.
        <a href="mailto:mohit.shirole@gbisinc.com">mohit.shirole@gbisinc.com</a>
      </p>

      <h2>Contact Information</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:{" "}
        <a href="mailto:mohit.shirole@gbisinc.com">mohit.shirole@gbisinc.com</a>
      </p>

    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'sans-serif',
    margin: '40px auto',
    maxWidth: '800px',
    lineHeight: 1.6,
  }
};

export default PrivacyPolicy;
